function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#crown_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.558 13.73H3.442a.56.56 0 01-.462-.245C1.38 11.141 1.259 6.631 1.25 5.962l-.001-.08a.56.56 0 01.558-.559h.001a.56.56 0 01.56.558l.001.095a2.969 2.969 0 002.964 2.872 2.968 2.968 0 002.965-2.965c0-.31.25-.56.56-.56h1.285c.309 0 .56.25.56.56a2.969 2.969 0 002.965 2.965 2.969 2.969 0 002.965-2.967.56.56 0 011.12.002l-.002.08c-.01.668-.132 5.178-1.73 7.522a.56.56 0 01-.463.245z",
  fill: "#FCC354"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 3.414a1.81 1.81 0 00-1.808 1.808A1.81 1.81 0 009.5 7.03a1.81 1.81 0 001.808-1.808A1.81 1.81 0 009.5 3.414zM1.808 4.81A1.81 1.81 0 000 6.617a1.81 1.81 0 001.808 1.808 1.81 1.81 0 001.808-1.808A1.81 1.81 0 001.808 4.81zM17.192 4.81a1.81 1.81 0 00-1.808 1.807c0 .997.811 1.808 1.808 1.808A1.81 1.81 0 0019 6.617a1.81 1.81 0 00-1.808-1.807zM15.558 15.565H3.442a.56.56 0 01-.56-.56v-1.668h13.236v1.668a.56.56 0 01-.56.56z",
  fill: "#FFA73A"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "crown_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h19v19H0z"
})));
function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgCrown;